'use strict';

/** @type {import('.')} */
module.exports = Error;



/*****************
 ** WEBPACK FOOTER
 ** ./~/es-errors/index.js
 ** module id = 851
 ** module chunks = 0
 **/